module.exports = __webpack_public_path__ + "images/emoji/grey_exclamation.e7f12e849ab681824e68.png";